import type { HomeScreenTaskSuggestion } from '@frontend/react-domain';
import { Icon, Text, XStack, YStack } from '@frontend/web-react';
import { getIconNameByTaskCategory } from '@frontend/web/components/DomainSpecific/Tasks/TaskCategoryIcon/helper';

const DEFAULT_CARD_WIDTH = 320;

type SuggestionCardProps = {
  onPress: () => void;
  onRemove: (event: React.MouseEvent) => void;
  suggestion: HomeScreenTaskSuggestion;
  width?: number;
};

export const SuggestionCard = ({ onPress, onRemove, suggestion, width = DEFAULT_CARD_WIDTH }: SuggestionCardProps) => {
  const iconName = getIconNameByTaskCategory(suggestion.clusterLabel || 'Other. Undefined or Rare tasks.');

  return (
    <div
      className="shrink-0 bg-trueWhite rounded-lg border-1 border-borderTertiary p-md cursor-pointer hover:shadow-one transition-shadow"
      onClick={onPress}
      style={{ width }}
    >
      <YStack accessibilityLabel={suggestion.shortenedLabel || suggestion.draftDescription} className="gap-md">
        <XStack className="items-center justify-between">
          <div className="flex items-center justify-center rounded-full p-sm bg-cool-200">
            <Icon color="primary" name={iconName} size="md" />
          </div>
          <button
            aria-label="Remove suggestion"
            className="p-xs hover:bg-cool-100 rounded-full transition-colors"
            onClick={onRemove}
            type="button"
          >
            <Icon color="neutral" name="IconX" size="sm" />
          </button>
        </XStack>
        <YStack className="gap-xs">
          <Text className="font-medium" color="primary" lineClamp={1} type="p-md">
            {suggestion.shortenedLabel || suggestion.draftDescription}
          </Text>
          <Text color="secondary" lineClamp={1} type="p-sm">
            {suggestion.shortenedLabel ? suggestion.draftDescription : null}
          </Text>
        </YStack>
      </YStack>
    </div>
  );
};
